export const ID_TOKEN_STORAGE_KEY = "idToken";
export const ID_TOKEN_EXPIRY_STORAGE_KEY = "idTokenExpiryMs";
const LEGACY_SHARED_AUTH_COOKIE = "canary-auth";
const LEGACY_SHARED_COOKIE_DOMAIN = ".canaryai.com";

const evictLegacySharedAuthCookie = () => {
  if (typeof document === "undefined") return;
  try {
    document.cookie = `${LEGACY_SHARED_AUTH_COOKIE}=; path=/; domain=${LEGACY_SHARED_COOKIE_DOMAIN}; SameSite=Lax; max-age=0;`;
  } catch {
  }
};

export const getStoredIdToken = () => {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage?.getItem(ID_TOKEN_STORAGE_KEY);
    if (stored) return stored;
    return null;
  } catch {
    return null;
  }
};

export const getStoredTokenExpiryMs = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage?.getItem(ID_TOKEN_EXPIRY_STORAGE_KEY);
    if (!raw) return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const getTokenExpiryFromJwt = (token) => {
  if (!token) return null;
  try {
    const [, payload] = token.split(".");
    if (!payload) return null;
    const decoded = JSON.parse(atob(payload));
    if (!decoded?.exp) return null;
    return decoded.exp * 1000;
  } catch {
    return null;
  }
};

export const getEmailFromIdToken = (token) => {
  if (!token) return null;
  try {
    const [, payload] = token.split(".");
    if (!payload) return null;
    const decoded = JSON.parse(atob(payload));
    const email =
      decoded?.email ||
      decoded?.user_email ||
      decoded?.preferred_username ||
      decoded?.upn ||
      (Array.isArray(decoded?.firebase?.identities?.email)
        ? decoded.firebase.identities.email[0]
        : null);
    return typeof email === "string" ? email : null;
  } catch {
    return null;
  }
};

export const persistIdToken = (token) => {
  if (typeof window === "undefined") return;
  if (!token) return;
  try {
    window.localStorage?.setItem(ID_TOKEN_STORAGE_KEY, token);
    const expiry = getTokenExpiryFromJwt(token);
    if (expiry) {
      window.localStorage?.setItem(ID_TOKEN_EXPIRY_STORAGE_KEY, String(expiry));
    } else {
      window.localStorage?.removeItem(ID_TOKEN_EXPIRY_STORAGE_KEY);
    }
    evictLegacySharedAuthCookie();
  } catch {
  }
};

export const clearStoredIdToken = () => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage?.removeItem(ID_TOKEN_STORAGE_KEY);
    window.localStorage?.removeItem(ID_TOKEN_EXPIRY_STORAGE_KEY);
    evictLegacySharedAuthCookie();
  } catch {
  }
};
